/* eslint-disable no-dupe-class-members */
import { isNumber, isUndefined } from '../typeGuards';
import { convert } from './conversions';
import { MeasurementUnit } from './types';
function isMeasurementUnit(measurement) {
    return Object.values(MeasurementUnit).includes(measurement);
}
function determineUnit(input) {
    const regexResult = /[^+-.eE\d]*$/.exec(input);
    if (!regexResult) {
        throw Error(`Measurement conversion failed. "${input}" was not able to be parsed for the measurement unit.`);
    }
    const fromUnits = regexResult[0].toLowerCase().trim();
    if (!isMeasurementUnit(fromUnits)) {
        throw Error(`Measurement conversion failed.
        "${fromUnits}" is not recognized. Use "in", "ft", "yd", "mm", cm", "m", or "pt" instead.`);
    }
    return fromUnits;
}
function determineValue(input) {
    const dotRegex = /\..*\./.exec(input);
    if (dotRegex) {
        throw Error(`Measurement conversion failed. "${input}" has multiple "." characters which is invalid.`);
    }
    const value = parseFloat(input);
    if (Number.isNaN(value)) {
        throw Error(`Measurement conversion failed. "${input}" returned a NaN value.`);
    }
    return value;
}
export class Measurement {
    constructor(input, unit) {
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "unit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (isNumber(input)) {
            if (isUndefined(unit)) {
                throw new Error('A "unit" argument must be passed when using a number input.');
            }
            this.value = input;
            this.unit = unit;
        }
        else {
            this.value = determineValue(input);
            this.unit = determineUnit(input);
        }
    }
    get measurement() {
        return `${this.value}${this.unit}`;
    }
    /**
     * The following methods handle a conversion when a cdif string is provided to the class if a cdif string was not the input they will not return a value
     */
    get mm() {
        return convert(this.value, this.unit, MeasurementUnit.MM);
    }
    get cm() {
        return convert(this.value, this.unit, MeasurementUnit.CM);
    }
    get m() {
        return convert(this.value, this.unit, MeasurementUnit.M);
    }
    get in() {
        return convert(this.value, this.unit, MeasurementUnit.IN);
    }
    get ft() {
        return convert(this.value, this.unit, MeasurementUnit.FT);
    }
    get yd() {
        return convert(this.value, this.unit, MeasurementUnit.YD);
    }
    get pt() {
        return convert(this.value, this.unit, MeasurementUnit.PT);
    }
}
//# sourceMappingURL=Measurement.js.map